import { IFundDataModel } from '../../data-models/fund.data-model';

export function fundLabelForTransaction(
  row: { fundId?: number | null; familyId?: number | null } | undefined,
  fundsById: Map<number, IFundDataModel>
): string {
  if (!row) {
    return '';
  }
  if (row.fundId != null) {
    return fundsById.get(row.fundId)?.name ?? '';
  }
  if (row.familyId != null) {
    for (const fund of fundsById.values()) {
      if (fund.fundKind === 'family' && fund.familyId === row.familyId) {
        return fund.name;
      }
    }
  }
  return '';
}
